var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_22377)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86794 12.1384L13.8728 15.1232L13.9876 15.0129C16.0406 13.042 19.5 14.4835 19.5 17.3017C19.5 19.0651 18.043 20.5 16.2525 20.5C14.0853 20.5 12.5174 18.4348 13.1418 16.3847L13.1879 16.2333L8.18307 13.2485L8.06833 13.3731C7.27186 14.2382 6.12304 14.7818 4.84773 14.7818C2.45054 14.7818 0.5 12.8608 0.5 10.5C0.5 8.13913 2.45058 6.21814 4.84773 6.21814C6.12304 6.21814 7.27186 6.76168 8.06832 7.62686L8.18306 7.7515L13.1879 4.76666L13.1418 4.61531C12.5165 2.56236 14.0883 0.5 16.2525 0.5C18.0431 0.5 19.5 1.93489 19.5 3.69825C19.5 6.51245 16.0427 7.96013 13.9876 5.98707L13.8728 5.87683L8.86794 8.86164L8.92727 9.01969C9.28502 9.97277 9.28479 11.0279 8.92727 11.9803L8.86794 12.1384ZM18.181 3.69822C18.181 2.65079 17.3161 1.79898 16.2525 1.79898C15.189 1.79898 14.324 2.65079 14.324 3.69822C14.324 4.74571 15.1889 5.59753 16.2525 5.59753C17.3161 5.59753 18.181 4.74563 18.181 3.69822ZM1.81893 10.4999C1.81893 12.1449 3.17746 13.4828 4.84765 13.4828C6.51792 13.4828 7.87632 12.1449 7.87632 10.4999C7.87632 8.85503 6.51792 7.51713 4.84765 7.51713C3.17742 7.51713 1.81893 8.85499 1.81893 10.4999ZM14.324 17.3017C14.324 18.3492 15.1889 19.201 16.2525 19.201C17.3161 19.201 18.181 18.3491 18.181 17.3017C18.181 16.2542 17.3161 15.4024 16.2525 15.4024C15.1889 15.4024 14.324 16.2543 14.324 17.3017Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_22377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconWhite);
export default __webpack_public_path__ + "static/media/share_icon_white.3ff898fc16e28fdd4fd18964333f3260.svg";
export { ForwardRef as ReactComponent };